import { useState, useEffect } from 'react';
import { BREAKPOINTS } from '../styles/breakpoints';

export function useMediaQuery(query) {
  const [matches, setMatches] = useState(() => window.matchMedia(query).matches);

  useEffect(() => {
    const mql = window.matchMedia(query);
    const handleChange = () => setMatches(mql.matches);
    handleChange();
    mql.addEventListener('change', handleChange);
    return () => mql.removeEventListener('change', handleChange);
  }, [query]);

  return matches;
}

export const useIsTabletOrBelow = () => useMediaQuery(`(max-width: ${BREAKPOINTS.tablet}px)`);
export const useIsMobile = () => useMediaQuery(`(max-width: ${BREAKPOINTS.mobile}px)`);
export const useIsLaptopSm = () => useMediaQuery(`(max-width: ${BREAKPOINTS.laptopSm}px)`);
